import React from 'react'
import { Link } from 'react-router'
import { PersonAffiliation } from '../../../types'
import { collectPersonRecentActivity } from '../../../utils/personRecentActivity'
import { PersonActivityRowList } from './PersonActivityRows'

interface PersonRecentActivityProps {
  affiliations: PersonAffiliation[]
  /** Max rows to show (default 5). */
  limit?: number
  /** When set, shows a right-aligned link to the full Aktivitet tab. */
  viewAllTab?: string
}

const PersonRecentActivity: React.FC<PersonRecentActivityProps> = ({
  affiliations,
  limit = 5,
  viewAllTab,
}) => {
  const rows = collectPersonRecentActivity(affiliations, limit)

  return (
    <div className="min-w-0">
      <p className="text-[13px] font-semibold text-ink-500 mb-2">
        Seneste aktivitet
      </p>
      {rows.length === 0 ? (
        <p className="text-xs text-ink-500 mb-0.5">Ingen registreret aktivitet.</p>
      ) : (
        <ul className="space-y-0 min-w-0 mb-0.5" aria-label="Seneste aktivitet">
          <PersonActivityRowList rows={rows} />
        </ul>
      )}
      {viewAllTab && (
        <p className="text-right mt-0.5 mb-0 leading-tight">
          <Link
            to={{ search: `?tab=${viewAllTab}` }}
            className="text-xs text-ink-500 hover:text-ink underline underline-offset-2 decoration-rule hover:decoration-signal"
          >
            Se al aktivitet &gt;
          </Link>
        </p>
      )}
    </div>
  )
}

export default PersonRecentActivity
